<template>
    <rkm-layout-body title="Lista de autorizador">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-autorizador-create' })"
                authorize="store-cadastro-autorizador"
                color="primary"
            >
                Cadastrar autorizador
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/cadastro/autorizador/List'

export default {
    components: {List},
}
</script>
